class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const removeFilterNode = this.querySelector('a')
    if (!removeFilterNode) return;
    
    removeFilterNode.addEventListener('click', (e) => {
      e.preventDefault();
      
      // Get the URL from the remove link
      const removeUrl = new URL(removeFilterNode.href);
      
      // Check if we're using storefront filters (collection-filters-form)
      const filtersForm = this.closest('collection-filters-form') || document.querySelector('collection-filters-form');
      
      if (filtersForm && typeof filtersForm.renderPage === 'function') {
        // Storefront filters - use renderPage
        const currentPath = window.location.pathname;
        const currentTagParts = currentPath.split('/').filter(p => p && p.startsWith('_'));

        if (currentTagParts.length > 0) {
          history.replaceState({}, '', currentPath);
        }

        filtersForm.renderPage(removeUrl.searchParams.toString());
      } else {
        // Tags filter or direct navigation - navigate to URL
        window.location.href = removeUrl.href;
      }
    });
  }
}

customElements.define('facet-remove', FacetRemove);